module.exports = __webpack_public_path__ + "static/media/logo_footer.327f97bf.svg";